import { TimeFormatPipe } from './time-format.pipe';
import { LoaderService } from './services/loader.service';
import { ClientesPymesService } from './services/clientes-pymes.service';
import { JwtHelper } from 'angular2-jwt';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
//Servicios

import { PerfilesService } from './services/perfiles.service';
import { MensajesService } from './services/mensajes.service';
import { RoleGuardService } from './services/role-guard.service';
import { UsuariosService } from './services/usuarios.service';
import { ExpedientesService } from './services/expedientes.service';
import { IntervinientesService } from './services/intervinientes.service';
import { ClientesService } from './services/clientes.service';
import { AuthService } from './services/auth.service';
import { AuthGuardService } from './services/auth-guard.service';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { APP_ROUTING } from "./app.routes";
import { FormsModule } from '@angular/forms';

import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpInterceptor } from '@angular/common/http';

import { AppComponent } from './app.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { ClientesComponent } from './components/clientes/clientes.component';
import { ExpendientesComponent } from './components/expendientes/expendientes.component';
import { IntervinientesComponent } from './components/intervinientes/intervinientes.component';
import { UsuariosComponent } from './components/usuarios/usuarios.component';
import { PerfilesComponent } from './components/perfiles/perfiles.component';
import { FaqComponent } from './components/faq/faq.component';
import { MensajesComponent } from './components/mensajes/mensajes.component';
import { IntervinienteComponent } from './components/interviniente/interviniente.component';
import { ClienteComponent } from './components/cliente/cliente.component';
import { LoginComponent } from './components/login/login.component';
import { MiperfilComponent } from './components/miperfil/miperfil.component';
import { DireccionComponent } from './components/direccion/direccion.component';
import { ConsultaComponent } from './components/consulta/consulta.component';
import { ExpedienteComponent } from './components/expediente/expediente.component';
import { AdjuntoComponent } from './components/adjunto/adjunto.component';
import { ExpedienteIntervinienteComponent } from './components/expediente-interviniente/expediente-interviniente.component';
import { ExpedienteActuacionComponent } from './components/expediente-actuacion/expediente-actuacion.component';
import { ActuacionAdjuntoComponent } from './components/actuacion-adjunto/actuacion-adjunto.component';
import { ProvisionComponent } from './components/provision/provision.component';
import { SuplidoComponent } from './components/suplido/suplido.component';

import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { MensajeComponent } from './components/mensaje/mensaje.component';
import { CKEditorModule } from 'ng2-ckeditor';
import { ConsultasComponent } from './components/consultas/consultas.component';
import { LoginAdminComponent } from './components/login-admin/login-admin.component';
import { LoginAdminPymesComponent } from './components/login-admin-pymes/login-admin-pymes.component';
import { UsuarioComponent } from './components/usuario/usuario.component';
import { PerfilComponent } from './components/perfil/perfil.component';
import { CifnifDirective } from './directives/cifnif.directive';
import { ClientesPymesComponent } from './components/clientes-pymes/clientes-pymes.component';
import { ClientePymeComponent } from './components/cliente-pyme/cliente-pyme.component';
import { LaboralComponent } from './components/laboral/laboral.component';
import { FiscalComponent } from './components/fiscal/fiscal.component';
import { ContableComponent } from './components/contable/contable.component';
import { LaboralDocComponent } from './components/laboral-doc/laboral-doc.component';
import { FiscalDocComponent } from './components/fiscal-doc/fiscal-doc.component';
import { ContableDocComponent } from './components/contable-doc/contable-doc.component';
import { DocumentosComponent } from './components/documentos/documentos.component';
import { LoadingComponent } from './components/loading/loading.component';
import { LoaderInterceptorService } from './services/loader-interceptor.service';
import { PreconsultaComponent } from './components/preconsulta/preconsulta.component';
import { PreservicioComponent } from './components/preservicio/preservicio.component';
import { RecuperarClienteComponent } from './components/recuperar-cliente/recuperar-cliente.component';
import { RecuperarPymeComponent } from './components/recuperar-pyme/recuperar-pyme.component';
import { DateFormatPipe } from './date-format.pipe';
import { DateTimeFormatPipe } from './date-time-format.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { TpvokComponent } from './components/tpvok/tpvok.component';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    ClientesComponent,
    ExpendientesComponent,
    IntervinientesComponent,
    UsuariosComponent,
    PerfilesComponent,
    FaqComponent,
    MensajesComponent,
    IntervinienteComponent,
    ClienteComponent,
    LoginComponent,
    MiperfilComponent,
    DireccionComponent,
    ConsultaComponent,
    ExpedienteComponent,
    AdjuntoComponent,
    ExpedienteIntervinienteComponent,
    ExpedienteActuacionComponent,
    ActuacionAdjuntoComponent,
    ProvisionComponent,
    SuplidoComponent,
    MensajeComponent,
    ConsultasComponent,
    LoginAdminComponent,
    LoginAdminPymesComponent,
    UsuarioComponent,
    PerfilComponent,
    CifnifDirective,
    ClientesPymesComponent,
    ClientePymeComponent,
    LaboralComponent,
    FiscalComponent,
    ContableComponent,
    LaboralDocComponent,
    FiscalDocComponent,
    ContableDocComponent,
    DocumentosComponent,
    LoadingComponent,
    PreconsultaComponent,
    PreservicioComponent,
    RecuperarClienteComponent,
    RecuperarPymeComponent,
    DateFormatPipe,
    DateTimeFormatPipe,
    TimeFormatPipe,
    SafeHtmlPipe,
    TpvokComponent
  ],
  imports: [
    BrowserModule,
    APP_ROUTING,
    HttpModule,
    HttpClientModule,
    FormsModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    CKEditorModule,
    Ng4LoadingSpinnerModule.forRoot()

  ],
  providers: [
    ClientesService,
    ClientesPymesService,
    IntervinientesService,
    ExpedientesService,
    UsuariosService,
    MensajesService,
    AuthService,
    AuthGuardService,
    RoleGuardService,
    PerfilesService,
    JwtHelper,
    LoaderService,
    DateFormatPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi:true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi:true
    }
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts